module.exports = __webpack_public_path__ + "static/media/card2.d4169db1.png";